import type { ReactiveController, ReactiveControllerHost } from 'lit';
import { DEPRECATIONS } from './deprecations.data.js';

type Key = keyof typeof DEPRECATIONS;

type Component = typeof DEPRECATIONS[Key]['Component'];

type KeyByComponent<C extends Component> = {
  [K in Key]: typeof DEPRECATIONS[K]['Component'] extends C ? K : never
}[Key];

export class DeprecationsController<T extends ReactiveControllerHost, C extends Component, K extends KeyByComponent<C>> implements ReactiveController {
  host: T;
  private value: Set<K> = new Set();
  private name: C;

  constructor(host: T, name: C) {
    (this.host = host).addController(this);
    this.name = name;
  }

  hostUpdate(): void {
  }

  add(key: K) {
    if (this.value.has(key)) { return; }
    this.value.add(key);
    this.host.requestUpdate();
  }

  has(key: K) {
    return this.value.has(key);
  }

  delete(key: K) {
    if (!this.value.has(key)) { return; }
    this.value.delete(key);
    this.host.requestUpdate();
  }
}
